import {
  nouser,
  isuser
} from './accessdenied-forms' 

(function($) {  
  
  const redirectonlogin = window.localStorage.getItem('RedirectOnLogin')
  if(redirectonlogin) {

    window.localStorage.removeItem('RedirectOnLogin');
    window.location.href = redirectonlogin
    return false
  }

  const urlParams = new URLSearchParams(window.location.search)

  const accessdenied = urlParams.get('accessdenied')
  if(accessdenied) { 

    const code = urlParams.get('code')
    const userdata =  atob(decodeURIComponent(code))
    const data = JSON.parse(userdata)

    $('html').css('overflow', 'hidden')
    $('body').addClass('AccessDenied')

    if(data.weldinghubstatus == 'nouser') {

      $('body').append(nouser())

    } else {

      $('body').append(isuser(data))
    }

    const $accessdenied = $('#AccessDenied')
    const $popup = $accessdenied.find('.AccessDenied')

    const $nouser = $popup.find('.NoUser')
    const $loginbutton = $nouser.find('.Login')
    const $registerbutton = $popup.find('.Register')

    const $shouldregister = $popup.find('.ShouldRegister')
    const $askregister = $shouldregister.find('.AskRegister')
    const $shouldregisterbutton = $shouldregister.find('.ShouldRegister')

    const $requestingregister = $popup.find('.RequestingRegistry')
    const $requestingregistererror = $popup.find('.RequestingRegistryError')

    const $shouldregisterconfirmation = $popup.find('.ShouldRegisterConfirmation')

    const $close = $popup.find('.Close')

    $loginbutton
    .on(
      'click',
      function() {

        $('html').css('overflow', 'inherit')
        $('body').removeClass('AccessDenied')
        $accessdenied.remove()

        localStorage.setItem(
          'RedirectOnLogin', 
          window.location.pathname + '/' + accessdenied
        )

        $('.xoo-el-login-tgr.menu-item.menu-item-type-custom.menu-item-object-custom')
        .click()
      }
    )

    $registerbutton
    .on(
      'click',
      function() {
        
        window.localStorage.removeItem('RedirectOnLogin');

        $('html').css('overflow', 'inherit')
        $('body').removeClass('AccessDenied')
        $accessdenied.remove()

        $('<div class="xoo-el-reg-tgr"></div>').appendTo("body").click()

        const $registerform = $('.xoo-el-modal .xoo-el-form-container .xoo-el-section[data-section="register"] .xoo-el-action-form.xoo-el-form-register')
        $registerform.append('<input type="hidden" name="academy_register_weldinghub" value="requested">')
      }
    )

    $askregister
    .on(
      'click',
      function() {
        
        window.localStorage.removeItem('RedirectOnLogin');

        const $this = $(this)
        $shouldregisterbutton.prop('disabled', !$this.is(':checked'))
      }
    )

    $shouldregisterbutton
    .on(
      'click',
      function() {
        
        window.localStorage.removeItem('RedirectOnLogin');

        $shouldregister.hide()
        $requestingregister.show()

        fetch(
          `/wp-json/academy/partnersupport/weldinghubpartner/request/${ data.userid }`,
          {
            method: 'GET',
            headers: {
              'X-WP-Nonce': academy_web_site.nonce
            }
          }
        )
        .then(result => {

          setTimeout(() => {
            
            $requestingregister.hide()

            if(result.status != 200) {

              $requestingregistererror.show()

            } else {
              
              $shouldregisterconfirmation.show()
            }

          }, 600)
        })

        return false
      }
    )

    $close
    .on(
      'click',
      function() {
        
        window.localStorage.removeItem('RedirectOnLogin');

        $('html').css('overflow', 'inherit')
        $('body').removeClass('AccessDenied')
        $accessdenied.remove()
      }
    )
  }

})(jQuery)